import React, { useEffect, useState } from 'react';
import {Table, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import Page from '../../pagination/pagination';
import { DeleteMarkup, GetMarkup } from '../../../entities/action/action';

const AirportMarkupList = (props)=>{
    const [dataSet,updateDataSet] = useState([]);
    const [count,updateCount] = useState(0)
    const postPerPage = 20;
    const [currentPage,updateCurrentPage] = useState(1);
    const indexOfLast = currentPage*postPerPage;
    const indexOfFirst = indexOfLast - postPerPage;
    const currentPosts = dataSet.slice(indexOfFirst,indexOfLast);
    const handleChangePage = (event,value)=>{
        updateCurrentPage(value)
    }
    useEffect(()=>{
        updateCount(Math.ceil(dataSet.length/postPerPage))
    },[dataSet])

    const onDeleteHandle = async(id) => {
        if(id){
            const response = await DeleteMarkup(id);
            if(response.success){
                alert("Successfully removed markup");
                window.location.reload();
            }else{
                alert("Failed to removed markup");
            }
        }
    }

    useEffect(()=>{
        
        (async()=>{
            let arr = await GetMarkup("flight");
            if(arr){
                updateDataSet(arr);
            }
        })()
    },[])
     
    return(
        <Container fluid style={{padding:'0'}}>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Markup For</th>
                        <th>Amount Type</th>
                        <th>Total Markup Amount</th>
                        <th>Markup Type</th>
                        <th>Lowest</th>
                        <th>Highest</th>
                        <th>Markup Calculation</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        currentPosts.length>0?currentPosts.map((data,key)=>
                            <tr key={key}>
                                <td>{key+1}</td>
                                <td>{data.markupFor}</td>
                                <td>{data.amountType}</td>
                                <td>{Math.round(data.markupAmount*(1+data.markupGst/100))}</td>
                                <td>{data.markupType}</td>
                                <td>{data.lowestMarkupRange}</td>
                                <td>{data.highestMarkupRange}</td>
                                <td>{data.markupCalculation}</td>
                                <td className={classes.CenterRow}>
                                    <Button style={{margin:'auto 1%'}} variant="danger" onClick={()=>onDeleteHandle(data?.id)}>Delete</Button>
                                    <Button style={{margin:'auto 1%'}} variant="success">Edit</Button>
                                </td>
                            </tr>
                        ):null
                    }
                </tbody>
            </Table>
            <div style={{display:'flex',justifyContent:'center',margin:'15px 0'}}>
                <Page count={count} change={handleChangePage} page={currentPage}/> 
            </div>
        </Container>
    )
}
export default AirportMarkupList;